import tw from "twin.macro"
import { ImageBlock2Left1RightProps } from "./StackedImageModule.d"
import { Image } from "../../../atoms/Image"
import Icon from "../../../atoms/Icon"

const ImageBlock2Left1Right: React.FC<ImageBlock2Left1RightProps> = ({
  alignment,
  imageBottomLeft,
  imageRight,
  imageTopLeft,
  setClickedImage,
}) => {
  return (
    <div css={[tw`hidden lg:(block grid grid-cols-1 grid-cols-3 gap-5)`]}>
      <div css={[tw`grid grid-cols-subgrid col-span-1 gap-5`]}>
        {imageTopLeft && (
          <div css={[tw`relative w-full`]}>
            <Image
              imageData={imageTopLeft?.image}
              css={[
                tw`object-cover rounded-2xl`,
                tw`w-full h-[220px]  lg:h-[240px]`,
              ]}
            />
            <button
              onClick={() => {
                setClickedImage(imageTopLeft?.image?.asset?._id)
              }}
              css={[
                tw`absolute z-[49] top-4 right-4 bg-gray-100 rounded-full shadow-2 p-2 px-2! opacity-100 hover:opacity-80`,
              ]}
            >
              <Icon.Expand color={"black"} css={[tw`h-6 w-6`]} />
            </button>
          </div>
        )}
        {imageBottomLeft && (
          <div css={[tw`relative w-full`]}>
            <Image
              imageData={imageBottomLeft?.image}
              css={[
                tw`object-cover rounded-2xl`,
                tw`w-full h-[220px] lg:h-[428px]`,
              ]}
            />
            <button
              onClick={() => {
                setClickedImage(imageBottomLeft?.image?.asset?._id)
              }}
              css={[
                tw`absolute z-[49] top-4 right-4 bg-gray-100 rounded-full shadow-2 p-2 px-2! opacity-100 hover:opacity-80`,
              ]}
            >
              <Icon.Expand color={"black"} css={[tw`h-6 w-6`]} />
            </button>
          </div>
        )}
      </div>
      <div
        css={[
          tw`col-span-1 lg:col-span-2`,
          alignment == "bottom" ? tw`content-end` : tw`content-start`,
        ]}
      >
        {imageRight && (
          <div css={[tw`relative w-full`]}>
            <Image
              imageData={imageRight?.image}
              css={[tw`object-cover rounded-2xl`, tw`w-full lg:h-[665px]`]}
            />
            <button
              onClick={() => {
                setClickedImage(imageRight?.image?.asset?._id)
              }}
              css={[
                tw`absolute z-[49] top-4 right-4 bg-gray-100 rounded-full shadow-2 p-2 px-2! opacity-100 hover:opacity-80`,
              ]}
            >
              <Icon.Expand color={"black"} css={[tw`h-6 w-6`]} />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageBlock2Left1Right
